import { Box, Image } from "@chakra-ui/react";
import React from "react";
import Property_map from "../img/property-map.png";

const PropertyMap = ({ propertyDetail }) => {

  const mapURL = `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GMAPS_API_KEY}&q=${propertyDetail?.lat},${propertyDetail?.lng}&zoom=19&maptype=satellite`;
  console.log(mapURL);
  return (
    <Box>

      <iframe
      w={"100%"}
      title={"map"}
      width={"100%"}
      height="450"
      frameborder="0"
      style={{ border: 0 }}
      src={mapURL}
      allowfullscreen
    ></iframe>
    </Box>
  );
};

export default PropertyMap;
